import langDe from 'element-ui/lib/locale/lang/de';
import translations from './translations';
import 'moment/locale/de';

export default {
  ...translations,
  ...langDe,
};
